export default "__VITE_ASSET__BuvNuqt$__"